import { defineMessages, FormattedMessage } from 'react-intl';

export const messages = defineMessages({
  totalAmountPayable: {
    id: 'payment.financeCalculator.totalAmountPayable',
    defaultMessage: 'Total amount payable',
  },
  yourProvider: {
    id: 'payment.financeCalculator.yourProvider',
    defaultMessage: 'Your provider',
  },
  monthlyLoanTerm: {
    id: 'payment.financeCalculator.monthlyLoanTerm',
    defaultMessage: 'Monthly loan term',
  },
  yourMonthlyPayments: {
    id: 'payment.financeCalculator.yourMonthlyPayments',
    defaultMessage: 'Your monthly payments',
  },
  months: {
    id: 'payment.financeCalculator.months',
    defaultMessage: 'Months',
  },
  cembrapay: {
    id: 'payment.financeCalculator.cembrapay',
    defaultMessage: 'Cembrapay',
  },
  taeg: {
    id: 'payment.financeCalculator.taeg',
    defaultMessage: 'taeg',
  },
  totalPrice: {
    id: 'payment.financeCalculator.totalPrice',
    defaultMessage: 'total price',
  },
  creditplusBank: {
    id: 'payment.financeCalculator.creditplusBank',
    defaultMessage: 'Creditplus Bank',
  },
  netLoanAmount: {
    id: 'payment.financeCalculator.netLoanAmount',
    defaultMessage: 'Net loan amount',
  },
  creditPlusAdvantagesText: {
    id: 'financeCalculator.creditPlusAdvantagesText',
    defaultMessage:
      'Pay quick and simple in monthly installments with Creditplus Bank. Your advantages:',
  },
  easyOnlineApplicationProcess: {
    id: 'financeCalculator.easyOnlineApplicationProcess',
    defaultMessage: 'Easy online application process',
  },
  smoothOnlineIdentificationVideoIdent: {
    id: 'financeCalculator.smoothOnlineIdentificationVideoIdent',
    defaultMessage: 'Smooth online identification through VideoIdent',
  },
  zeroApr: {
    id: 'financeCalculator.zeroApr',
    defaultMessage: '0% APR',
  },
  noHiddenFees: {
    id: 'financeCalculator.noHiddenFees',
    defaultMessage: 'No hidden fees',
  },
  creditPlusCalculatorTips1: {
    id: 'financeCalculator.creditPlusCalculatorTips1',
    defaultMessage:
      'Net loan amount = total loan amount, 0,00% APR, 0,00 % interest rate p.a.. Creditworthiness assumed.',
  },

  creditPlusCalculatorTips2: {
    id: 'financeCalculator.creditPlusCalculatorTips2',
    defaultMessage:
      'The information represent 6a Abs. 4 PAngV. Credit brokering is done exclusively for Creditplus Bank AG, Augustenstraße 7, 70178 Stuttgart',
  },
});

export const AgosText = ({
  amount,
  maxAmount,
  minAmount,
  monthlyPayment,
  months,
  totalAmountPayable,
}: {
  amount: JSX.Element;
  maxAmount: JSX.Element;
  minAmount: JSX.Element;
  monthlyPayment: JSX.Element;
  months: number;
  totalAmountPayable: JSX.Element;
}) => (
  <FormattedMessage
    defaultMessage='Financing is eligible for watch orders up to {maxAmount} with a maximum duration of 60 months. First installment due in 30 days – Example: {amount} (total credit amount) in {months} installments of {monthlyPayment} – Fixed APR 0% AER 0%. The AER represents the total cost of credit expressed as an annual percentage and in some cases may differ from zero solely due to decimal rounding. All costs zeroed – total amount due {totalAmountPayable}. Offer valid until 12/31/2026. Pre-contractual information in the document “European Standard Information about Consumer Credit” (SECCI) on the dedicated web page together with a copy of the contractual text, at the time of loading the non-binding financing request. Subject to Financial approval. Advertising message. Breitling is a non-exclusive credit intermediary.'
    id='financeCalculator.AgosText'
    values={{
      minAmount,
      maxAmount,
      amount,
      months,
      monthlyPayment,
      totalAmountPayable,
    }}
  />
);
